import { useState } from 'react';

export function useDescriptionModal() {
  const [visible, setVisibility] = useState(false);

  const show = setVisibility.bind(null, true);
  const hide = setVisibility.bind(null, false);

  return {
    visible,
    hide,
    show,
  };
}
